import React from "react";
import StandardCard from "../../standard-card/StandardCard";
import { getCmsData } from "../../../functions";

const About = () => {
  const cmsData = getCmsData("aboutSectionDataCMS");
  if (!cmsData) return null;

  const { heading, headingURL, cards } = cmsData;

  return (
    <section id="about">
      <div className="container-fluid">
        <h2>
          <a href={headingURL}>{heading}</a>
        </h2>
        <div className="row">
          <StandardCard data={cards[0]} />
          <StandardCard data={cards[1]} />
          <div className="w-100"></div>
          <StandardCard data={cards[2]} />
          <StandardCard data={cards[3]} />
        </div>
      </div>
    </section>
  );
};

export default About;
